import { Component, Input } from '@angular/core';
import { CanvasLoaderType, CanvasStringConstants } from '../canvas.model';
import { CanvasService } from '../canvas.service';

@Component({
  selector: 'app-canvas-loader',
  templateUrl: './canvas-loader.component.html',
  styleUrl: './canvas-loader.component.scss',
})
export class CanvasLoaderComponent {
  loaderTypes = CanvasLoaderType;
  stringConstants = CanvasStringConstants;
  @Input() loaderType: string = this.loaderTypes.TYPING;
  @Input() robotStatus: string = this.loaderTypes.ROBOT_LOADING;

  constructor(public canvasService: CanvasService) {}
}
